import { render } from "./twelve-packages.vue?vue&type=template&id=ac311716"
import script from "./twelve-packages.vue?vue&type=script&lang=js"
export * from "./twelve-packages.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__